import React, { ReactElement } from 'react';
import FormatService from '../../services/format-service';
import useStylesModalButtonBlock from './modal-button-block.styles';

const ModalButtonBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isRight,
    isFixed,
    isFixedMedium,
    className,
    children,
  } = props;

  const { classes } = useStylesModalButtonBlock();

  const fixedClassName: string | undefined = isFixed ? classes.modalButtonBlockFixed : undefined;
  const fixedMediumClassName: string | undefined = isFixedMedium ? classes.modalButtonBlockFixedMedium : undefined;
  const rightClassName: string | undefined = isRight ? classes.modalButtonBlockRight : undefined;

  return (
    <div
      className={FormatService.formatClassNames(
        classes.modalButtonBlock, fixedClassName, fixedMediumClassName, rightClassName, className,
      )}
    >
      {children}
    </div>
  );
});

export default ModalButtonBlock;
